<template>
  <div>
    <!-- <div class="timeline-cover-photo"  :style="`background-image: url('${institutionDetails.bg_image}')`">
    </div> -->
    <v-parallax
      v-if="institutionDetails"
      height="300"
      class="timeline-cover-photo"
      :src="institutionDetails.bg_image"
    >
    </v-parallax>

    <v-row justify="center" no-gutters>
      <v-col cols="12" md="8">
        <v-row>
          <v-col cols="12">
            <h1 class="text-left mx-4">Franchise Dashboard</h1>
          </v-col>
          <v-col cols="12">
            <v-card class="mb-2 mx-4" elevation="0">
              <v-row align="center">
                <v-col cols="12" md="4">
                  <v-row align="center">
                    <v-col cols="6">
                      <img
                        class="mx-2"
                        height="100px"
                        :src="currentInstitution.logo"
                      />
                    </v-col>
                    <v-col cols="6">
                      <h3 class="text-left">{{ currentInstitution.name }}</h3>
                      <h5 class="text-left">
                        {{ currentInstitution.location }}
                      </h5>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" md="8">
                  <v-row align="center">
                    <v-col cols="6" :md="currentUser.is_admin ? '3' : '4'">
                      <!-- <img src="../assets/icons/graduation.png" width=70> -->
                      <i
                        class="fas fa-graduation-cap fa-2x secondary--text"
                      ></i>
                      <h3>
                        {{
                          Helper.totalSum(
                            institutionDetails.children_institutions,
                            "total_students"
                          )
                        }}
                      </h3>
                      <h5>Students</h5>
                    </v-col>
                    <v-col cols="6" :md="currentUser.is_admin ? '3' : '4'">
                      <i class="fas fa-user-friends fa-2x secondary--text"></i>
                      <h3>
                        {{
                          Helper.totalSum(
                            institutionDetails.children_institutions,
                            "total_staff"
                          )
                        }}
                      </h3>
                      <h5>Staff</h5>
                    </v-col>
                    <v-col cols="6" :md="currentUser.is_admin ? '3' : '4'">
                      <i class="fas fa-chalkboard fa-2x secondary--text"></i>
                      <h3>
                        {{
                          Helper.totalSum(
                            institutionDetails.children_institutions,
                            "total_classrooms"
                          )
                        }}
                      </h3>
                      <h5>Classroom</h5>
                    </v-col>
                    <v-col v-if="currentUser.is_admin" cols="6" :md="currentUser.is_admin ? '3' : '4'">
                      <i class="fas fa-rupee-sign fa-2x secondary--text"></i>
                      <h3>
                        {{
                          Helper.currencyFormat(
                            Helper.totalSum(
                              institutionDetails.children_institutions,
                              "total_revenue"
                            )
                          )
                        }}
                      </h3>
                      <h5>Revenue</h5>
                    </v-col>
                  </v-row>
                </v-col>

              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <h2 class="text-left mx-4">All Institutions</h2>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              prepend-inner-icon="mdi-magnify"
              outlined
              dense
              class="rounded-input mx-4"
              label="Search"
              v-model="search"
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="8">
        <div v-if="filteredInstitutions.length">
          <v-card
            class="mb-8 mx-4"
            v-for="institution in filteredInstitutions"
            :key="institution.id"
            @click="authenticateUserAndSwitchInstitution(institution)"
          >
            <v-row align="center">
              <v-col cols="12" md="4">
                <v-row align="center">
                  <v-col cols="6">
                    <img class="mx-2" height="100px" :src="institution.logo" />
                  </v-col>
                  <v-col cols="6">
                    <h3 class="text-left">{{ institution.name }}</h3>
                    <h5 class="text-left">{{ institution.location }}</h5>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" md="8">
                <v-row align="center">
                  <v-col cols="6" :md="currentUser.is_admin ? '3' : '4'">
                    <!-- <img src="../assets/icons/graduation.png" width=70> -->
                    <i class="fas fa-graduation-cap fa-2x secondary--text"></i>
                    <h3>{{ institution.total_students }}</h3>
                    <h5>Students</h5>
                  </v-col>
                  <v-col cols="6" :md="currentUser.is_admin ? '3' : '4'">
                    <i class="fas fa-user-friends fa-2x secondary--text"></i>
                    <h3>{{ institution.total_staff }}</h3>
                    <h5>Staff</h5>
                  </v-col>
                  <v-col cols="6" :md="currentUser.is_admin ? '3' : '4'">
                    <i class="fas fa-chalkboard fa-2x secondary--text"></i>
                    <h3>{{ institution.total_classrooms }}</h3>
                    <h5>Classroom</h5>
                  </v-col>
                  <v-col v-if="currentUser.is_admin" cols="6" :md="currentUser.is_admin ? '3' : '4'">
                    <i class="fas fa-rupee-sign fa-2x secondary--text"></i>
                    <h3>
                      {{ Helper.currencyFormat(institution.total_revenue) }}
                    </h3>
                    <h5>Revenue</h5>
                  </v-col>
                </v-row>
              </v-col>


            </v-row>
          </v-card>
        </div>
        <div v-else><h3>No Institutions Found</h3></div>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar.visible">
      {{ snackbar.text }}
      <template>
        <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
    <v-overlay :value="isLoggingLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import api from "@api/index";
import { mapGetters, mapActions } from "vuex";
import endpoints from "@api/repository";
import Helper from "@utils/misc";
import authApi from "@api/auth/base";

export default {
  name: "FranchiseDashboard",
  computed: {
    ...mapGetters([
      "isLoading",
      "accessToken",
      "currentUser",
      "currentInstitution",
    ]),
    apiEssentials() {
      return {
        setLoading: this.setLoading,
        accessToken: this.accessToken,
        handleErrorsFunction: this.handleApiErrors,
      };
    },
    filteredInstitutions() {
      if (this.institutionDetails == null) return [];
      return this.institutionDetails.children_institutions.filter(
        (institution) =>
          institution.name.toLowerCase().includes(this.search.toLowerCase()) ||
          institution.location.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },
  data() {
    return {
      Helper: Helper,
      search: "",
      snackbar: {
        visible: false,
        text: "",
      },
      institutionDetails: null,
      isLoggingLoading: false,
    };
  },
  methods: {
    ...mapActions([
      "setLoading",
      "saveTempParentData",
      "setTokens",
      "setCurrentUser",
      "setCurrentInstitution",
      "setFeeSessionData",
    ]),
    // handles api errors
    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },

    async getChildrenInstitutions() {
      var url = `${endpoints.institutionsViewSet}${this.currentInstitution.id}/`;
      this.institutionDetails = await api.call(this.apiEssentials, url);
    },

    // get institution data [images]
    async getInstitutionDetails(code) {
      var response;
      response = await api.handleApi({
        apiEssentials: this.apiEssentials,
        url: endpoints.getInstitutionDetailsByCode + code + "/",
        responseVar: response,
      });
      return response;
    },

    async authenticateUserAndSwitchInstitution(institution) {
      this.isLoggingLoading = true;
      var body = { institution_id: institution.id };
      var tokens = await api.call(
        this.apiEssentials,
        endpoints.authenticateSubordinateUser,
        api.Methods.POST,
        body
      );
      this.saveTempParentData();

      // handle token errors
      if (!Helper.handleErrors(tokens, this.handleApiError)) return;

      // set tokens in state
      await this.setTokens(tokens);

      // get currentUser
      let currentUser = await authApi.getMyDetails(tokens.access);
      let subordinateInstitution = await this.getInstitutionDetails(
        institution.code
      );

      // handle currentUser errors
      if (currentUser instanceof Error) {
        this.setLoading(false);
        this.snackbar.text = "There was a server error. Please, try again!";
        this.snackbar.visible = true;
        return;
      }

      //set user in state
      await this.setCurrentUser(currentUser);

      //set institution in state
      await this.setCurrentInstitution(subordinateInstitution);
      this.setLoading(false);

      // get active fee sessions
      this.updateFeeSessionData();

      // get fee sessions from api
      // await this.getFeeSessions();

      if (this.currentUser !== null && this.$route.query.next != null) {
        this.$router.push(this.$route.query.next);
      } else {
        if (this.currentInstitution.is_super_institution)
          this.$router.push({ name: "FranchiseDashboard" });
        else this.$router.push({ name: "Dashboard" });
      }
      this.isLoggingLoading = false;
    },
    async updateFeeSessionData() {
      // console.log("updateFeeSessionData executed");
      var url = endpoints.getFeeSessions;
      var fee_sessions = await api.call(this.apiEssentials, url);
      localStorage.removeItem("activeFeeSession");
      this.setFeeSessionData(fee_sessions);
    },
    handleApiError(err) {
      console.log(err);
      console.log("handling errors");
      this.setLoading(false);
      if (err.response) {
        if (err.response.status == 401) {
          this.formErrors.genError = "Incorrect username or password";
        }
        if (err.response.status == 412) {
          this.formErrors.resetPasswordUsernameError =
            "Account does not have Email linked. Please contact administrator.";
        }
      } else {
        this.snackbar.text = "Unable to process request";
        this.snackbar.visible = true;
      }
    },
  },
  created() {
    if(!this.currentInstitution.is_super_institution) {
      this.$router.push({ name: 'Dashboard' });
      return;
    }
    this.getChildrenInstitutions();
  },
};
</script>

<style scoped>
.timeline-cover-photo {
  margin-top: -25px;
  margin-bottom: 10px;
}
</style>